import AppWrap from './AppWrapContainer';

export default AppWrap;
